module.exports = __webpack_public_path__ + "img/img3.b9858890.jpg";